// P15-close — ImpersonationBanner
// Renders a fixed top amber bar with countdown + exit when the
// sessionStorage `auth_token` carries `impersonated: true`.
// Reads `exp` for the countdown, auto-clears on expiry.

import React, { useEffect, useState } from "react";

function decodeJwt(tok) {
  try {
    const payload = tok.split(".")[1];
    // base64url → base64
    const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

function clearAndBail() {
  sessionStorage.removeItem("auth_token");
  sessionStorage.removeItem("impersonation_token");
  // Try close; fall back to redirect.
  window.close();
  setTimeout(() => {
    if (!window.closed) window.location.href = "/auth";
  }, 200);
}

export default function ImpersonationBanner() {
  const [claims, setClaims] = useState(null);
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const tok = sessionStorage.getItem("auth_token");
    if (!tok) return;
    const c = decodeJwt(tok);
    if (!c || c.impersonated !== true) return;
    setClaims(c);
    const exp = (c.exp || 0) * 1000;
    setRemaining(Math.max(0, exp - Date.now()));
    const id = setInterval(() => {
      const left = Math.max(0, exp - Date.now());
      setRemaining(left);
      if (left <= 0) { clearInterval(id); clearAndBail(); }
    }, 1000);
    return () => clearInterval(id);
  }, []);

  if (!claims) return null;

  const mins = Math.floor(remaining / 60000);
  const secs = Math.floor((remaining % 60000) / 1000);
  const ts = `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  const who = claims.name || claims.email || claims.sub || "user";

  return (
    <div data-testid="imp-banner" style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      background: "#f59e0b", color: "#000",
      padding: "8px 16px", display: "flex", alignItems: "center",
      justifyContent: "space-between", fontSize: 13, fontWeight: 500,
      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    }}>
      <span>
        ⚠️ Superadmin impersonation active — logged in as{" "}
        <span style={{ fontFamily: "monospace" }}>{who}</span>
        {claims.project_id && <span> · project <span style={{ fontFamily: "monospace" }}>{String(claims.project_id).slice(0,8)}</span></span>}
      </span>
      <span style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <span data-testid="imp-banner-countdown" style={{ fontFamily: "monospace" }}>⏱ {ts}</span>
        <button
          data-testid="imp-banner-exit"
          onClick={clearAndBail}
          style={{
            background: "#000", color: "#f59e0b", border: "1px solid #000",
            padding: "4px 12px", borderRadius: 3, fontSize: 12, cursor: "pointer",
            fontWeight: 600,
          }}
        >Exit Impersonation</button>
      </span>
    </div>
  );
}
